<template>
  <div class="container">
    <div class="encontre">Encontre por categoria</div>
    <div class="d-flex align-items-center justify-content-center justify-content-md-start mb-4">
      <select class="form-control" v-model="indexCategoria">
        <option v-for="(categoria, index) in categorias" :value="index" >{{categoria.categoria}}</option>
      </select>
    </div>
    <div class="table-responsive-xl">
      <table class="table">
        <div v-for="disciplina in conteudoAtivo.disciplinas">
          <h3>{{disciplina.disciplina}}</h3>
          <hr :class="'disciplina' + ' cat'+indexCategoria">
          <div v-b-toggle="'collapse-'+curso.id" v-for="curso in disciplina.cursos" class="curso-collapse mb-2">
            <div class="d-flex flex-column accordion" role="tablist">
              <div class="d-flex justify-content-between curso-title">
                <div>
                  <i class="fas fa-list-ul"></i> {{ curso.curso }}
                </div>
                <div>
                  <span class="when-closed">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                  </span>
                  <span class="when-opened">
                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <b-collapse :id="'collapse-'+curso.id" v-if="ferramenta != 'resumos'" role="tab" accordion="accordion">
                <div class="d-flex justify-content-between conteudo" v-for="ementa in curso.ementas">
                  <div>{{titulo(ementa.topico)}}</div>
                  <div>
                    <a @click="$router.push(url(curso, ementa))" class="btn btn-roxo">Abrir</a>
                  </div>
                </div>
              </b-collapse>
              <b-collapse :id="'collapse-'+curso.id" v-else role="tab" accordion="accordion">
                <div class="d-flex justify-content-between conteudo" v-for="pdf in curso.pdfs">
                  <div>{{titulo(pdf)}}</div>
                  <div>
                    <a class="btn btn-roxo" target="_blank" :href="urlPdf(pdf)" @click="registraVisualizacao(pdf)">Abrir</a>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </table>
    </div>
  </div>
</template>

<script>
import FerramentaAPI from '@/api/ferramentas-api'
import ResumoAPI from '@/api/resumo-api'
export default {
  name: 'FerramentasItem',
  props: {
    ferramenta: String,
    conteudo: Array
  },
  data: function () {
    return {
      conteudoAtivo: {
        disciplinas: {
          cursos: {
            pdfs: []
          }
        }
      },
      ferramentaAtiva: '',
      indexCategoria: 0,
      categorias: []
    }
  },
  mounted () {
    this.conteudoAtivo = this.conteudo
    this.ferramentaAtiva = this.ferramenta
    this.carregaFerramenta()
  },
  watch: {
    ferramenta () {
      this.carregaFerramenta()
    },
    indexCategoria () {
      this.alteraCategoria()
    }
  },
  methods: {
    nomeItem (item) {
      switch (this.ferramenta) {
        case 'resumos':
          return item.titulo
        default:
          return ''
      }
    },
    dataCadastro: function (date) {
      if (date !== null) {
        let data = new Date(date)
        return ((data.getDate())) + '/' + ((data.getMonth() + 1)) + '/' + data.getFullYear()
      }
      return 'Data não informada'
    },
    url: function (curso, ementa, pdf) {
      return 'sala-de-aula/' + curso.referencia + '/' + ementa.modulo.referencia + '/' + ementa.licao.referencia + '/' + ementa.topico.referencia
    },
    urlPdf: function (pdf) {
      if (pdf.url.includes('apostila-web')) {
        return process.env.VUE_APP_BASE_FILES_URL + pdf.url
      } else {
        return process.env.VUE_APP_BASE_FILES_URL + 'apostila-web/' + pdf.url
      }
    },
    async carregaFerramenta () {
      const loader = this.$loading.show()
      let url = this.urlConsulta()
      this.conteudoAtivo = []
      this.categorias = []
      this.indexCategoria = 0
      let resposta = await url
      this.categorias = resposta
      this.conteudoAtivo = this.categorias[this.indexCategoria]
      loader.hide()
    },
    urlConsulta () {
      switch (this.ferramenta) {
        case 'resumos':
          return FerramentaAPI.listarResumos()
        case 'modelos-3d':
          return FerramentaAPI.listarModelos3D()
        case 'mapas-mentais':
          return FerramentaAPI.listarMapasMentais()
        default:
          return ''
      }
    },
    alteraCategoria () {
      if (this.categorias.length > 0) {
        this.conteudoAtivo = this.categorias[this.indexCategoria]
      }
    },
    titulo (item) {
      if (item.titulo) {
        return item.titulo
      } else {
        return item.topico
      }
    },
    async registraVisualizacao (pdf) {
      await ResumoAPI.registrarDownload(pdf.id)
    }
  }
}
</script>
